import gql from 'graphql-tag';
import { useMutation } from '@apollo/client';

export const LINK_MUTATION = gql`
  mutation ConditionalLink($type: String!) {
    link(type: $type) {
      url
      token
    }
  }
`;

export const CONDITIONAL_LINK_TYPES = {
  '/files': 'dossier',
  '/appointments': 'appointments',
  '/profile-settings': 'profile-settings'
};

export function getConditionalLinkType(href) {
  if (!href || typeof href !== 'string') return null;

  const path = href.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/';

  return CONDITIONAL_LINK_TYPES[path] || null;
}

export function goToResolvedLink({ url, token } = {}) {
  if (!url) return;

  if (!token) {
    window.location.href = url;
    return;
  }

  const form = document.createElement('form');

  form.method = 'POST';
  form.action = url;
  form.enctype = 'application/x-www-form-urlencoded';

  const input = document.createElement('input');

  input.type = 'hidden';
  input.name = 'token';
  input.value = token;

  form.appendChild(input);
  document.body.appendChild(form);
  form.submit();
}

export function useConditionalLink() {
  const [resolveLink] = useMutation(LINK_MUTATION);

  return async function go(path) {
    const type = getConditionalLinkType(path);

    try {
      if (type) {
        const { data } = await resolveLink({ variables: { type } });

        if (data?.link?.url) {
          goToResolvedLink(data.link);
          return;
        }
      }
    } catch (e) {
      // ignore
    }

    if (path) window.location.href = path;
  };
}
